import { z } from 'zod';

import { CustomDeviceConfiguration } from './CustomDeviceConfiguration';

export const CustomDeviceStateSchema = CustomDeviceConfiguration.extend({
  status: z.enum(['initializing', 'idle', 'busy', 'error']),
  modbusTCPConnection: z
    .object({
      isConnected: z.boolean(),
    })
    .optional(),
  message: z.string().optional(),
});

export type CustomDeviceState = z.infer<typeof CustomDeviceStateSchema>;
